import Bid from "../../models/v2/Bid";

export default {
    namespaced: true,
    state: {
        bidCount: 0,
        leftMenuOpen: null,
        rightMenuOpenCounter: 0,
        perPages: {},
    },
    mutations: {
        setLeftMenuOpen (state, value) {
            state.leftMenuOpen = value;
        },
        setPerPage(state, data) {
            state.perPages[data.name] = data.value;
        },
        rightMenuOpen(state) {
            state.rightMenuOpenCounter++;
        },
        rightMenuClose(state) {
            state.rightMenuOpenCounter--;
        },
        setBidCount(state, data) {
            state.bidCount = data;
        },
    },
    actions: {
        async getBidCount({commit}) {
            const response = await Bid.getNoVisibleCount();
            commit('setBidCount', response.count);
        },
    },
}
